import { render, staticRenderFns } from "./versus.vue?vue&type=template&id=3caec70e&"
import script from "./versus.vue?vue&type=script&lang=js&"
export * from "./versus.vue?vue&type=script&lang=js&"
import style0 from "./versus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports